import CheckboxLabel from './CheckboxLabel';

export default CheckboxLabel;
